import { Component, Input, OnDestroy, } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComponentSelectionStorageService } from 'src/tmc-common/services/component-selection-storage.service';
import { ProjectAdminContext, ProjectTitle } from '../../project.model';
import { AddProjectDialogComponent } from '../add-project-dialog/add-project-dialog.component';
import { environment } from 'src/environments/environment';
import { DialogService, HttpService } from '@sdbn/appclient';

const STORAGE_KEY = 'app-project-admin.settings';

@Component({
  selector: 'app-project-selection-header',
  templateUrl: './project-selection-header.component.html',
  styleUrls: ['./project-selection-header.component.scss']
})
export class ProjectSelectionHeaderComponent implements OnDestroy {

  projectAdminContext: ProjectAdminContext;
  projectAdminContextSubscription: Subscription;
  projectTitles = new Array<ProjectTitle>();

  @Input('projectAdminContext') set setSacClientContext(projectAdminContext: ProjectAdminContext) {
    this.projectAdminContext = projectAdminContext;

    this.projectAdminContextSubscription = projectAdminContext.contextReady.subscribe(() => {
      this.restoreSelectionFromStorage();
    }
    );
  }

  constructor(
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private dialogService: DialogService,
    private http: HttpService
  ) { }

  ngOnDestroy() {
    if (this.projectAdminContextSubscription) {
      this.projectAdminContextSubscription.unsubscribe();
    }
  }

  private restoreSelectionFromStorage() {
    const settings = this.componentSelectionStorageService.getWidgetSelection(STORAGE_KEY, this.projectAdminContext.widgetIdentifier);
    if (settings != null && settings.selectedProjects != null) {
      this.projectAdminContext.selectedProjects = settings.selectedProjects;
      if (this.projectAdminContext.selectedProjects.length > 0) {
        this.projectAdminContext.currentlyActiveProject = this.findStoredSelection();
      }
    }
    this.refreshTitles();
  }

  private findStoredSelection(): number {
    const settings = this.componentSelectionStorageService.getWidgetSelection(STORAGE_KEY, this.projectAdminContext.widgetIdentifier);
    return settings?.currentlyActiveProject;
  }

  private storeSettings() {
    const settings: any = {
      selectedProjects: this.projectAdminContext.selectedProjects,
      currentlyActiveProject: this.projectAdminContext.currentlyActiveProject
    };
    this.componentSelectionStorageService.saveWidgetSelection(STORAGE_KEY, this.projectAdminContext.widgetIdentifier, settings);
  }

  public closeProject(projectId: number) {
    const indexOf = this.projectAdminContext.selectedProjects.indexOf(projectId);
    this.projectAdminContext.selectedProjects.splice(indexOf, 1);
    this.projectAdminContext.currentlyActiveProject = null;

    this.storeSettings();

    if (indexOf === 0) {
      this.selectProject(this.projectAdminContext.selectedProjects[0]);
    } else {
      this.selectProject(this.projectAdminContext.selectedProjects[indexOf - 1]);
    }
    this.refreshTitles();
  }

  public selectProject(projectId: number) {
    if (this.projectAdminContext.selectedProjects.indexOf(projectId) >= 0) {
      this.projectAdminContext.currentlyActiveProject = projectId;
      this.storeSettings();
    }
  }

  public isProjectSelected(projectId: number) {
    if (this.projectAdminContext == null) {
      return;
    }

    return this.projectAdminContext.currentlyActiveProject === projectId;
  }

  public selectOrCreateProject() {
    this.dialogService.openLarge(AddProjectDialogComponent, {}).afterClosed(
    ).subscribe(projectId => {
      if (projectId != null) {
        if (this.projectAdminContext.selectedProjects.indexOf(projectId) < 0) {
          this.projectAdminContext.selectedProjects.push(projectId);
        }
        this.refreshTitlesAndSelectProject(projectId)
      }
    });
  }

  private refreshTitles() {
    this.refreshTitlesAndSelectProject(null);
  }

  private refreshTitlesAndSelectProject(projectId: number) {
    this.http.postWithContext<ProjectTitle[]>(environment.erpProjectEndpoint + '/titles', this.projectAdminContext.selectedProjects).subscribe(
      titles => {
        console.log('response is', titles);
        const projectTitles = new Array<ProjectTitle>();
        for (const title of titles) {
          projectTitles.push(new ProjectTitle(title));
        }

        const sortedTitles = new Array<ProjectTitle>();
        for (const projectId of this.projectAdminContext.selectedProjects) {
          const titleById = projectTitles.find(t => t.id === projectId);
          if (titleById != null) {
            sortedTitles.push(titleById);
          }
        }
        this.projectTitles = sortedTitles;
        if (projectId != null) {
          this.selectProject(projectId);
          this.storeSettings();
        }
      }, error => {
        console.log('error is', error);
      });
  }
}
